import { trackStructEvent } from "@snowplow/browser-tracker";
import { ONEPASS_CATEGORY } from "@analytics/consts";
export function emitUpsellModalImpression() {
  var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Upsell Modal";
  trackStructEvent({
    category: ONEPASS_CATEGORY,
    action: action,
    label: "Impression"
  });
}